export default "__VITE_ASSET__9ef91c15__"